<template>
  <div>
    <div v-if="isLoading">
      <OtherLoading />
    </div>
    <div v-else>
      <HeaderPanel
        title="ลูกค้าที่ได้รับสิทธิพิเศษ (Customer Privileged)"
        :filter="filter"
        @search="handleSearch"
        @clear="clearFilter"
      >
        <template v-slot:filter-option>
          <b-col>
            <InputText
              v-model="filter.telephone"
              textFloat="เบอร์โทรศัพท์ (Telephone)"
              placeholder="เบอร์โทรศัพท์ (Telephone)"
              type="text"
              name="telephone"
              className="mb-2"
              @onEnter="handleSearch"
            />
          </b-col>
          <b-col>
            <InputText
              v-model="filter.name"
              textFloat="ชื่อสมาชิก (Member Name)"
              placeholder="ชื่อสมาชิก (Member Name)"
              type="text"
              name="name"
              className="mb-2"
              @onEnter="handleSearch"
            />
          </b-col>
          <b-col>
            <b-form-group label-class="p-0" class="mb-2">
              <template #label>
                <b class="f-size-14">เดือนเกิด (Birth Month)</b>
              </template>
              <b-dropdown
                no-caret
                ref="dropdown"
                class="w-100 m-0"
                right
                variant="dropdown-customs"
                block
              >
                <template #button-content>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    เดือนเกิด ({{ filter.birthdayMonth.length }})
                    <font-awesome-icon class="arrow" icon="chevron-down" />
                  </div>
                </template>
                <template v-slot="{ ariaDescribedby }">
                  <b-form-checkbox
                    class="f-size-14 w-33 pr-1 mr-0"
                    v-model="birthdayMonthOptions"
                    aria-describedby="birthdayMonth"
                    aria-controls="birthdayMonth"
                    @change="birthdayMonthToggle"
                  >
                    ทั้งหมด
                  </b-form-checkbox>
                  <b-form-checkbox-group
                    v-model="filter.birthdayMonth"
                    :aria-describedby="ariaDescribedby"
                    class="f-size-14"
                    stacked
                  >
                    <b-form-checkbox
                      class="w-33 pr-1 mr-0"
                      :value="opt.id"
                      :id="opt.name"
                      v-for="opt of monthList"
                      :key="opt.id"
                      >{{ opt.name }}
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </template>
              </b-dropdown>
            </b-form-group>
          </b-col>
          <b-col>
            <InputSelect
              title="เพศ (Gender)"
              isRequired
              :options="genderList"
              v-model="filter.gender"
              @onDataChange="val => (filter.gender = val)"
              textField="name"
              valueField="id"
              class="mb-2"
            />
          </b-col>
          <b-col>
            <InputSelect
              title="Coupon"
              isRequired
              :options="couponList"
              v-model="filter.couponId"
              @onDataChange="val => (filter.couponId = val)"
              textField="name"
              valueField="id"
              class="mb-2"
            />
          </b-col>
          <b-col>
            <InputSelect
              title="สาขาที่ซื้อล่าสุด (Branch)"
              isRequired
              :options="branchList"
              v-model="filter.branchId"
              @onDataChange="val => (filter.branchId = val)"
              textField="name"
              valueField="id"
              class="mb-2"
            />
          </b-col>
          <b-col>
            <InputSelect
              title="เรียงลำดับ (Sort By)"
              isRequired
              :options="sortByList"
              v-model="filter.sortBy"
              @onDataChange="val => (filter.sortBy = val)"
              textField="name"
              valueField="id"
              class="mb-2"
            />
          </b-col>
        </template>
      </HeaderPanel>
      <div class="bg-white border-red mt-3">
        <b-row>
          <b-col>
            <b-table
              responsive
              striped
              hover
              :fields="fields"
              :items="items"
              :busy="isBusy"
              show-empty
              empty-text="No matching records found"
              class="table-main"
              :no-border-collapse="false"
            >
              <template v-slot:cell(member_id)="data">
                <router-link
                  :to="{
                    path: '/report/ref-sale-member',
                    query: {
                      telephone: data.item.telephone,
                      memberId: data.item.member_id,
                      memberName: data.item.first_name_th
                    }
                  }"
                >
                  <u> {{ data.item.member_id }}</u>
                </router-link>
              </template>
              <template v-slot:cell(first_name_th)="data">
                <p>{{ data.item.first_name_th || '-' }}</p>
                <p>{{ data.item.first_name_en || '-' }}</p>
              </template>
              <template v-slot:cell(last_name_th)="data">
                <p>{{ data.item.last_name_th || '-' }}</p>
                <p>{{ data.item.last_name_en || '-' }}</p>
              </template>
              <template v-slot:cell(birth_month)="data">
                {{ months[data.item.birth_month] || '-' }}
              </template>
              <template v-slot:cell(coupon_name)="data">
                <p>{{ data.item.coupon_name || '-' }}</p>
              </template>
              <template v-slot:cell(telephone)="data">
                <p>{{ data.item.telephone || '-' }}</p>
              </template>
              <template v-slot:cell(email)="data">
                <p>{{ data.item.email || '-' }}</p>
              </template>
              <template v-slot:cell(redeem_date)="data">
                <div v-if="data.item.redeem_date">
                  {{
                    $moment(data.item.redeem_date).format($formatDateNewFull)
                  }}
                </div>
                <div v-else>-</div>
              </template>
              <template v-slot:cell(used_coupon_deate)="data">
                <div v-if="data.item.used_coupon_deate">
                  {{
                    $moment(data.item.used_coupon_deate).format(
                      $formatDateNewFull
                    )
                  }}
                </div>
                <div v-else>-</div>
              </template>
              <template v-slot:cell(is_consent)="data">
                <div v-if="data.item.is_consent">ยินยอม</div>
                <div v-else>รอยินยอม</div>
              </template>
              <template v-slot:cell(action)="data">
                <div class="d-flex justify-content-center align-items-center">
                  <img
                    src="@/assets/images/icons/note.png"
                    alt="transfer"
                    class="action-img pointer"
                    width="20"
                    center
                    @click="$refs.modalNote.show(data.item)"
                  />
                </div>
              </template>
              <template v-slot:table-busy>
                <div class="text-center text-black my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="ml-2">Loading...</strong>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <Pagination
          @handleChangeTake="handleChangeTake"
          :pageOptions="pageOptions"
          :filter="filter"
          :rows="rows"
          @pagination="pagination"
        />
      </div>
    </div>
    <ModalNote ref="modalNote" :branchId="branchId" />
  </div>
</template>

<script>
import OtherLoading from '@/components/loading/OtherLoading';
import HeaderPanel from '@/components/HeaderPanel';
import Pagination from '@/components/Pagination';
import InputSelect from '@/components/inputs/InputSelect';
import InputText from '@/components/inputs/InputText';
import ModalNote from '@/components/customer/ModalNote';
import { mapGetters } from 'vuex';

export default {
  components: {
    OtherLoading,
    Pagination,
    HeaderPanel,
    InputSelect,
    InputText,
    ModalNote
  },
  name: 'Customer',
  data() {
    return {
      fields: [
        {
          key: 'member_id',
          label: 'รหัสสมาชิก'
        },
        {
          key: 'coupon_name',
          label: 'ชื่อคูปอง'
        },
        {
          key: 'first_name_th',
          label: 'ชื่อ'
        },
        {
          key: 'last_name_th',
          label: 'นามสกุล'
        },
        {
          key: 'telephone',
          label: 'เบอร์โทร'
        },
        {
          key: 'email',
          label: 'อีเมล'
        },
        {
          key: 'birth_month',
          label: 'เดือนเกิด'
        },
        {
          key: 'redeem_date',
          label: 'Redeem Date'
        },
        {
          key: 'total_spending',
          label: 'Total Spending'
        },
        {
          key: 'used_coupon_deate',
          label: 'วันที่ใช้สิทธิ'
        },
        {
          key: 'is_consent',
          label: 'Consent status'
        },
        {
          key: 'action',
          label: '',
          tdClass: 'text-center'
        }
      ],
      items: [],
      isBusy: false,
      isLoadingData: false,
      rows: 0,
      filter: {
        branchId: 0,
        page: 1,
        take : 10,
        telephone: '',
        name: '',
        gender: null,
        birthdayMonth: [],
        sortBy: '1',
        gender: '0',
        couponId: 0
      },
      pageOptions: [
        { value: 5, text: '5/ page' },
        { value: 10, text: '10 / page' },
        { value: 30, text: '30 / page' },
        { value: 50, text: '50 / page' },
        { value: 100, text: '100 / page' }
      ],
      months: [
        '-',
        'มกราคม',
        'กุมภาพันธ์',
        'มีนาคม',
        'เมษายน',
        'พฤษภาคม',
        'มิถุนายน',
        'กรกฎาคม',
        'สิงหาคม',
        'กันยายน',
        'ตุลาคม',
        'พฤศจิกายน',
        'ธันวาคม'
      ],
      selected: 0,
      isLoading: true,
      branchList: [],
      monthList: [],
      genderList: [],
      sortByList: [],
      couponList: [],
      productTypeList: [
        { value: 0, text: 'ทั้งหมด' },
        { value: 1, text: 'สินค้า' },
        { value: 2, text: 'บริการสปา' }
      ],
      today: null,
      birthdayMonthOptions: false
    };
  },
  computed: {
    ...mapGetters({
      branchId: 'getBranchId'
    })
  },
  watch: {
    'filter.birthdayMonth'(newValue) {
      if (newValue.length === 0) {
        this.birthdayMonthOptions = false;
      } else if (newValue.length === this.monthList.length) {
        this.birthdayMonthOptions = true;
      } else {
        this.birthdayMonthOptions = false;
      }
    }
  },
  created: async function () {
    this.today = this.$moment().format('YYYY-MM-DDT00:00:00');
    await this.getMonthList();
    await this.birthdayMonthToggle(true);
    this.getBranchList();
    this.getGenderList();
    this.getSortByList();
    this.getCouponList();
    await this.getList();
  },
  methods: {
    getList: async function () {
      this.isBusy = true;
      let payload = { ...this.filter };
      payload.skip = (payload.page - 1) * payload.take;

      payload.branch_id = payload.branchId;
      payload.birthday_month = payload.birthdayMonth.toString();
      payload.sort_by = payload.sortBy;
      payload.center_point = payload.centerPoint;
      payload.coupon_id = payload.couponId;

      this.isLoadingData = true;
      await this.axios
        .post(`${this.$baseUrl}/customer/customer_retrieve_sample`, payload)
        .then(data => {
          this.isLoading = false;
          if (data.result == 1) {
            this.items = data.detail;
            this.rows = data.total_count;
            this.isLoadingData = false;
          }
        });

      this.isBusy = false;
    },
    getBranchList: async function () {
      let list = [{ id: 0, name: 'ทั้งหมด' }];

      await this.axios
        .get(`${this.$baseUrl}/dropdown/get_branch_list`)
        .then(data => {
          if (data.result == 1) {
            this.branchList = list.concat(data.detail);
          }
        });
    },
    getMonthList: async function () {
      await this.axios
        .get(`${this.$baseUrl}/dropdown/get_month_list`)
        .then(data => {
          if (data.result == 1) {
            let filtered = data.detail.filter(item => item.id != '0');
            this.monthList = filtered;
          }
        });
    },
    getGenderList: async function () {
      await this.axios
        .get(`${this.$baseUrl}/dropdown/get_gender`)
        .then(data => {
          if (data.result == 1) {
            this.genderList = data.detail;
          }
        });
    },
    getSortByList: async function () {
      await this.axios
        .get(`${this.$baseUrl}/dropdown/get_sortby_list`)
        .then(data => {
          if (data.result == 1) {
            this.sortByList = data.detail;
          }
        });
    },
    getCouponList: async function () {
      let list = [{ id: 0, name: 'ทั้งหมด' }];
      await this.axios
        .get(`${this.$baseUrl}/dropdown/get_coupon_list`)
        .then(data => {
          if (data.result == 1) {
            this.couponList = list.concat(data.detail);
          }
        });
    },
    handleSearch(value) {
      this.pagination(1);
    },
    pagination(page) {
      this.filter.page = page;
      this.$emit('filterPage', this.filter);
      this.getList();
    },
    handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.take = value;
      this.$emit('filterPage', this.filter);
      this.getList();
    },
    async clearFilter() {
      this.filter = {
        branchId: 0,
        page: 1,
        take : 10,
        telephone: '',
        name: '',
        gender: null,
        birthdayMonth: [],
        sortBy: '1',
        gender: '0',
        couponId: 0
      };
      await this.birthdayMonthToggle(true);
      await this.getList();
    },
    birthdayMonthToggle(checked) {
      this.filter.birthdayMonth = checked
        ? this.monthList.map(el => el.id)
        : [];
    }
  }
};
</script>

<style lang="scss" scoped>
.time {
  color: #afafaf;
}
.line-clamp2 {
  word-break: break-word;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.badge {
  font-size: 85%;
  background-color: var(--secondary-color);
  color: var(--primary-color);
  max-width: max-content;
  font-weight: 100;
}
.badge-container {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
::v-deep .arrow {
  font-size: 12px;
  color: #333 !important;
}
::v-deep .btn-dropdown-customs {
  text-align: left !important;
  border: 1px solid #bcbcbc !important;
  font-size: 14px !important;
  padding: 8px 10px !important;
  border-radius: 10px !important;
}
</style>
